import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import FieldCombo from '../combos/FieldCombo';
import CourseCombo from '../combos/CourseCombo';
import TeacherCombo from '../combos/TeacherCombo';
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from "primereact/radiobutton";
import SchoolClassCombo from '../combos/SchoolClassCombo';
import { Col, Container, Form, Row } from 'react-bootstrap';
import StudentCombo from '../combos/StudentCombo';
import { responsivePropType } from 'react-bootstrap/esm/createUtilityClasses';


export default function StudentScores(props) {
  const [redirectUrl, setRedirectUrl] = useState("");
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [comboVisible, setComboVisible] = useState(false);
  const [scoreVisible, setScoreVisible] = useState(false);
  const [btnVisible, setBtnVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isDescriptional, setIsDescriptional] = useState(false);
  const [student, setStudent] = useState(null);
  const [schoolClass, setSchoolClass] = useState(null);

  const [scores, setScores] = useState([]);
  const [descriptionals, setDescriptionals] = useState([]);

  useEffect(() => {
    var user = util.getCurrentUser();
    if(user.Role === 5){
      setScoreVisible(true);
      setComboVisible(false);
      loadScores(user.UserId);
    }
    else if(user.Role === 6){
      setComboVisible(true);
    }
  }, []);

  const loadScores = function(stuId){
      setLoading(true);
      var params = {login:util.getTrustedUser(), studentId:stuId};
      var url = config.Server+`/school/student/continual-test/get`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  console.log("resopnse is> ", response);
                  var sc = response.schoolClass;
                  setSchoolClass(sc);
                  setIsDescriptional(response.isDescriptional);
                  var scs = response.scores;
                  console.log("scors is> ", scs);
                  setScores(scs);
                  var ds = response.descriptionals;
                  console.log("descriptionals is> ", ds);
                  setDescriptionals(ds);
                  setScoreVisible(true);
                  
                  setLoading(false);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  //setLoading(false);
              }
          })
          .catch(error => {
            console.log("error is>", error)
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              //setLoading(false);
          });
     
  }
  const onStudentSelected = function(value){
    setScoreVisible(false);
    setLoading(false);
    setStudent(value);
    var hasStu = false;
    if(value)if(value.id) hasStu = true;
    setBtnVisible(hasStu);
    setScoreVisible(hasStu);

  }
  return (
    <>
    {
      comboVisible?
      <Row>
        <Col md={3}>
          <StudentCombo value={student} onChange={(value)=>{ onStudentSelected(value.itemValue)}}  returnFullItem={true}/>
        </Col>
        <Col md={3} style={{paddingTop:"30px"}}>
          <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
            {btnVisible?<Button label="مشاهده نمرات" icon="pi pi-check" onClick={()=>{loadScores(student.id)}} severity="success" iconPos="right" loading={loading} />: <></>}
          </div>          
        </Col>
      </Row>
      :<></>
    }
      {
        scoreVisible?
        <div>
          {
            loading?
            <>loading...</>
            :
            <>
            <Container fluid>
              {
                schoolClass && schoolClass.id?
                <Row>
                  <Col>
                    کلاس: {schoolClass.name + ", " + schoolClass.field.title + ", پایه:" + util.getDegreeChar(schoolClass.degree)}
                  </Col>
                </Row>
                :<></>
              }
              <Row style={{overflow:"scroll", marginTop:"10px", marginBottom:"50px"}}>
                <Col md={12} style={{textAlign:"right"}}>
                  لیست نمرات {}
                </Col>
                <table border="1" style={{borderCollapse:'collapse', width:'100%'}}>
                  <thead>
                    <tr style={{backgroundColor:"#555", color:"#FFF"}}>
                      <td style={{textAlign:"center", width:"70px", padding:"5PX", border:"1px solid #b0b0b0"}}>#</td>
                      <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0"}}>تاریخ</td>
                      <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0"}}>معلم</td>
                      <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0"}}>درس</td>
                      <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0"}}>شرح</td>
                      <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0"}}>وضعیت</td>
                      <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0"}}>نمره</td>
                    </tr>
                  </thead>
                  <tbody>
                    {scores.map((score, scoreInd) => 
                      <tr>
                        <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0"}}>{scoreInd+1}</td>
                        <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0"}}>{util.SeperateDate(score.testDate)}</td>
                        <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0"}}>{score.teacher}</td>
                        <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0"}}>{score.course}</td>
                        <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0"}}>{score.comment}</td>
                        <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0"}}>{score.state}</td>
                        <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0"}}>{util.getScore(schoolClass.degree, score.score)}</td>
                      </tr>)}
                  </tbody>
                </table>
              </Row>
              {
                isDescriptional?
              <Row style={{overflow:"scroll", marginTop:"50px", marginBottom:"50px"}}>
                <Col md={12} style={{textAlign:"right"}}>
                  بازخورد توصیفی {}
                </Col>
                <table border="1" style={{borderCollapse:'collapse', width:'100%'}}>
                  <thead>
                    <tr style={{backgroundColor:"#555", color:"#FFF"}}>
                      <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0"}}>درس</td>
                      <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0"}}>خیلی خوب</td>
                      <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0"}}>خوب</td>
                      <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0"}}>قابل قبول</td>
                      <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0"}}>نیاز به تلاش بیشتر</td>
                    </tr>
                  </thead>
                  <tbody>
                    {descriptionals.map((desc, scoreInd) => 
                    <>
                      <tr style={{borderTop:"3px solid #555"}}>
                        <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0", textAlign:"center", verticalAlign:"middle"}} rowSpan={3}>{desc.course.name}</td>
                        <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0", textAlign:"right", verticalAlign:"top"}}>نقاط قوت:<br/>{desc.positiveCommentVeryGood}</td>
                        <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0", textAlign:"right", verticalAlign:"top"}}>نقاط قوت:<br/>{desc.positiveCommentGood}</td>
                        <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0", textAlign:"right", verticalAlign:"top"}}>نقاط قوت:<br/>{desc.positiveCommentAcceptable}</td>
                        <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0", textAlign:"right", verticalAlign:"top"}}>نقاط قوت:<br/>{desc.positiveCommentRejected}</td>
                      </tr>
                      <tr>
                        <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0", textAlign:"right", verticalAlign:"top"}}>نقاط ضعف:<br/>{desc.negativeCommentVeryGood}</td>
                        <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0", textAlign:"right", verticalAlign:"top"}}>نقاط ضعف:<br/>{desc.negativeCommentGood}</td>
                        <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0", textAlign:"right", verticalAlign:"top"}}>نقاط ضعف:<br/>{desc.negativeCommentAcceptable}</td>
                        <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0", textAlign:"right", verticalAlign:"top"}}>نقاط ضعف:<br/>{desc.negativeCommentRejected}</td>
                      </tr>
                      <tr>
                        <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0", textAlign:"right", verticalAlign:"top"}}>پیشنهاد:<br/>{desc.recommendationVeryGood}</td>
                        <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0", textAlign:"right", verticalAlign:"top"}}>پیشنهاد:<br/>{desc.recommendationGood}</td>
                        <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0", textAlign:"right", verticalAlign:"top"}}>پیشنهاد:<br/>{desc.recommendationAcceptable}</td>
                        <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0", textAlign:"right", verticalAlign:"top"}}>پیشنهاد:<br/>{desc.recommendationRejected}</td>
                      </tr>
                    </>
                    )}
                  </tbody>
                </table>
              </Row>
                :<></>
              }
            </Container>
            </>
          }
        </div>
        :
        <></>
      }
    </>
  );
}
